export const USER_ID_KEY = '@Auth:user_id';
export const ACCESS_TOKEN_KEY = '@Auth:access_token';
export const ACTIVITIES_KEY = '@Statics:activities';
